<!-- Collapsed state -->
<div *ngIf="!isExpanded"
  class="rounded-xl border border-neutral-border dark:border-dark-border bg-neutral-soft dark:bg-dark-tertiary px-3 py-2.5 flex items-center gap-3">
  <span class="w-7 h-7 rounded-lg bg-info/15 flex items-center justify-center shrink-0">
    <span class="material-symbols-rounded text-base text-info">groups</span>
  </span>
  <div class="flex-1 min-w-0">
    <div class="text-[13px] font-semibold text-gray-900 dark:text-dark-text truncate">{{ collapsedLabel }}</div>
  </div>
  <button type="button" (click)="isExpanded = true"
    class="h-7 px-2.5 rounded-full bg-white dark:bg-dark-secondary border border-neutral-border dark:border-dark-border text-[11px] font-medium text-gray-600 dark:text-dark-text hover:text-gray-900 transition-colors shrink-0">
    {{ TEXT.COMMON.EDIT }}
  </button>
  <button type="button" (click)="removed.emit()"
    class="w-7 h-7 rounded-full hover:bg-white dark:hover:bg-dark-secondary text-gray-400 inline-flex items-center justify-center shrink-0 transition-colors">
    <span class="material-symbols-rounded text-base">close</span>
  </button>
</div>

<!-- Expanded state -->
<div *ngIf="isExpanded"
  class="rounded-xl border border-neutral-border dark:border-dark-border bg-neutral-soft dark:bg-dark-tertiary p-3 space-y-3">

  <!-- Header -->
  <div class="flex items-center gap-3">
    <span class="w-7 h-7 rounded-lg bg-info/15 flex items-center justify-center shrink-0">
      <span class="material-symbols-rounded text-base text-info">groups</span>
    </span>
    <span class="flex-1 text-[13px] font-semibold text-gray-900 dark:text-dark-text">{{
      TEXT.FIXED_EXPENSE_FORM.LABELS.SHARE_WITH_GROUP }}</span>
    <button *ngIf="selectedGroup" type="button" (click)="isExpanded = false"
      class="w-7 h-7 rounded-full hover:bg-white dark:hover:bg-dark-secondary text-gray-400 inline-flex items-center justify-center shrink-0 transition-colors">
      <span class="material-symbols-rounded text-base">expand_less</span>
    </button>
    <button type="button" (click)="removed.emit()"
      class="w-7 h-7 rounded-full hover:bg-white dark:hover:bg-dark-secondary text-gray-400 inline-flex items-center justify-center shrink-0 transition-colors">
      <span class="material-symbols-rounded text-base">close</span>
    </button>
  </div>

  <!-- Group picker -->
  <div class="relative">
    <button type="button" (click)="groupPickerOpen = !groupPickerOpen"
      class="w-full h-11 bg-white dark:bg-dark-secondary border border-neutral-border dark:border-dark-border rounded-xl px-3 inline-flex items-center justify-between text-left transition-shadow"
      [class.ring-2]="groupPickerOpen" [class.ring-brand-primary]="groupPickerOpen"
      [class.ring-opacity-40]="groupPickerOpen">
      <span *ngIf="selectedGroup"
        class="text-[13px] font-semibold text-gray-900 dark:text-dark-text truncate">{{ selectedGroup.name }}</span>
      <span *ngIf="!selectedGroup" class="text-[13px] text-gray-400 dark:text-dark-muted">{{
        TEXT.FIXED_EXPENSE_FORM.LABELS.SELECT_GROUP }}</span>
      <span class="material-symbols-rounded text-xl text-gray-400 transition-transform"
        [class.rotate-180]="groupPickerOpen">expand_more</span>
    </button>

    <div *ngIf="groupPickerOpen"
      class="absolute z-10 left-0 right-0 top-full mt-1.5 bg-white dark:bg-dark-secondary border border-neutral-border dark:border-dark-border rounded-xl shadow-lg overflow-hidden">
      <div class="max-h-52 overflow-y-auto p-1">
        <button *ngFor="let g of groups" type="button" (click)="selectGroup(g.id)"
          class="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-left transition-colors hover:bg-neutral-soft dark:hover:bg-dark-tertiary"
          [class.bg-neutral-soft]="selectedGroupId === g.id"
          [class.dark:bg-dark-tertiary]="selectedGroupId === g.id">
          <span class="flex-1 text-[13px] font-semibold text-gray-900 dark:text-dark-text truncate">{{ g.name }}</span>
          <span *ngIf="g.id === defaultGroupId"
            class="material-symbols-rounded text-sm text-brand-primary shrink-0">star</span>
          <span *ngIf="selectedGroupId === g.id"
            class="material-symbols-rounded text-lg text-brand-primary shrink-0">check_circle</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Split type -->
  <div *ngIf="selectedGroupId && splitOptions.length && showSplitPicker"
    class="flex items-center gap-1 p-1 rounded-full bg-white dark:bg-dark-secondary border border-neutral-border dark:border-dark-border">
    <button *ngFor="let opt of splitOptions" type="button" (click)="splitTypeChanged.emit(opt.key)"
      class="flex-1 h-7 rounded-full text-[11px] font-medium transition-colors"
      [class.bg-brand-primary]="splitType === opt.key" [class.text-zinc-900]="splitType === opt.key"
      [class.text-gray-500]="splitType !== opt.key" [class.dark:text-dark-muted]="splitType !== opt.key">
      {{ opt.label }}
    </button>
  </div>

  <!-- División automática (Según ingresos / Porcentaje fijo): el backend
       calcula el split; se puede anular solo para este gasto. -->
  <div *ngIf="selectedGroupId && isAutoSplitDivision && !splitOverrideEnabled" class="flex items-center justify-between px-1 py-0.5">
    <span class="text-[12px] text-gray-400 dark:text-dark-muted">División automática</span>
    <button type="button" (click)="splitOverrideToggled.emit(true)"
      class="text-[11px] font-medium text-ocean hover:underline">
      {{ TEXT.TRANSACTIONS.OVERRIDE_SPLIT_LABEL }}
    </button>
  </div>

  <!-- Todo en común: no se reparte, solo se registra el gasto/ingreso. -->
  <div *ngIf="selectedGroupId && isCommonDivision" class="px-1 py-0.5">
    <span class="text-[12px] text-gray-400 dark:text-dark-muted">Gasto en común — no genera deuda</span>
  </div>

  <!-- Marcar como deuda (TAR-325 Req 8) -->
  <div *ngIf="showGeneratesDebtToggle" class="flex items-center justify-between px-1 py-1 gap-3">
    <div class="min-w-0">
      <div class="text-[12px] font-medium text-gray-700 dark:text-dark-text">{{ TEXT.TRANSACTIONS.GENERATES_DEBT_LABEL }}</div>
      <div class="text-[11px] text-gray-400 dark:text-dark-muted">
        {{ generatesDebt ? TEXT.TRANSACTIONS.GENERATES_DEBT_HINT_ON : TEXT.TRANSACTIONS.GENERATES_DEBT_HINT_OFF }}
      </div>
    </div>
    <button type="button" role="switch" [attr.aria-checked]="generatesDebt"
      (click)="generatesDebtChanged.emit(!generatesDebt)"
      class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ocean"
      [ngClass]="generatesDebt ? 'bg-brand-primary' : 'bg-gray-300 dark:bg-dark-border'">
      <span class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform"
        [ngClass]="generatesDebt ? 'translate-x-6' : 'translate-x-1'"></span>
    </button>
  </div>

  <!-- Tu ingreso (solo grupos "Según ingresos") -->
  <div *ngIf="selectedGroup?.division === 'income'" class="px-1 py-0.5">
    <button type="button" (click)="openIncomeModal.emit()" class="text-[11px] font-medium text-ocean hover:underline">
      {{ TEXT.TRANSACTIONS.MY_INCOME_LINK }}
    </button>
  </div>

  <!-- Default group status row -->
  <ng-container *ngIf="selectedGroupId">

    <!-- Estado 1: grupo NO es predeterminado -->
    <div *ngIf="!selectedGroupIsDefault"
      class="flex items-center justify-between px-1 py-0.5">
      <span class="text-[12px] text-gray-400 dark:text-dark-muted select-none leading-none">
        {{ TEXT.GROUPS.SET_AS_DEFAULT_ADDON }}
      </span>
      <button type="button" (click)="onToggleDefault()"
        class="group w-7 h-7 rounded-full flex items-center justify-center transition-colors hover:bg-brand-primary/10 active:scale-95"
        [attr.aria-label]="TEXT.GROUPS.SET_AS_DEFAULT_ADDON">
        <span class="material-symbols-rounded text-base text-zinc-400 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors">
          star_border
        </span>
      </button>
    </div>

    <!-- Estado 2: grupo ES predeterminado -->
    <div *ngIf="selectedGroupIsDefault"
      class="flex items-center justify-between px-1 py-0.5">
      <span class="inline-flex items-center gap-1 h-5 px-2 rounded-full bg-brand-primary/10 dark:bg-amber-900/20">
        <span class="material-symbols-rounded text-amber-600 dark:text-amber-400"
          style="font-size: 11px; line-height: 1;">star</span>
        <span class="text-[11px] font-medium text-amber-700 dark:text-amber-400 leading-none">
          {{ TEXT.GROUPS.DEFAULT_BADGE }}
        </span>
      </span>
      <button type="button" (click)="onToggleDefault()"
        class="text-[11px] text-zinc-400 dark:text-dark-muted hover:text-zinc-600 dark:hover:text-dark-text transition-colors leading-none"
        [attr.aria-label]="TEXT.GROUPS.REMOVE_DEFAULT">
        {{ TEXT.GROUPS.REMOVE_DEFAULT }}
      </button>
    </div>

  </ng-container>

  <!-- Members list -->
  <div *ngIf="selectedGroupId && members.length" class="space-y-1">
    <div *ngFor="let m of members"
      class="flex items-center gap-2.5 bg-white dark:bg-dark-secondary border border-neutral-border dark:border-dark-border rounded-lg px-2.5 py-1.5">
      <div [ngClass]="getMemberAvatarColor(m.name || m.email)"
        class="w-6 h-6 rounded-full flex items-center justify-center text-white text-[10px] font-semibold shrink-0">
        {{ getMemberInitials(m.name || m.email) }}
      </div>
      <div class="flex-1 text-[12px] font-medium text-gray-900 dark:text-dark-text truncate">
        {{ m.name || m.email }}
      </div>

      <!-- Equal + checkboxes (transaction-form mode) -->
      <ng-container *ngIf="showSplitPicker && isEqualSplit && showMemberCheckboxes">
        <button type="button" (click)="memberToggled.emit(m.id)"
          class="w-6 h-6 rounded-md border flex items-center justify-center transition-all"
          [ngClass]="isMemberSelected(m.id)
            ? 'bg-brand-primary border-brand-primary text-white'
            : 'border-neutral-border dark:border-dark-border bg-white dark:bg-dark-tertiary text-transparent'">
          <span class="material-symbols-rounded text-sm">check</span>
        </button>
      </ng-container>

      <!-- Equal + no checkboxes (fixed-expense-form mode) -->
      <ng-container *ngIf="showSplitPicker && isEqualSplit && !showMemberCheckboxes">
        <div class="text-[12px] font-semibold text-gray-900 dark:text-dark-text tabular-nums">50%</div>
      </ng-container>

      <!-- Paid-by / "¿Quién lo cargó?" check: shown for every mode, including "Todo en común" and auto-split without override -->
      <button type="button" (click)="paidByChanged.emit(m.id)"
        [attr.aria-label]="showPayerOnly ? TEXT.TRANSACTIONS.WHO_LOADED_IT : null"
        class="material-symbols-rounded text-base transition-colors shrink-0"
        [class.text-brand-primary]="paidById === m.id"
        [class.text-gray-300]="paidById !== m.id">
        check_circle
      </button>

      <!-- Non-equal: paid-by row shows the auto-completed remainder (read-only) -->
      <ng-container *ngIf="showSplitPicker && showSplitConfig && m.id === paidById">
        <div class="text-[11px] font-semibold text-gray-500 dark:text-dark-muted shrink-0 tabular-nums">
          <span *ngIf="splitType.toUpperCase() === 'EXACT'">{{ paidByRemainingAmount | number:'1.0-2' }}</span>
          <span *ngIf="splitType.toUpperCase() === 'PERCENTAGE'">{{ paidByRemainingPercentage }}%</span>
        </div>
      </ng-container>

      <!-- Non-equal: other members' split value input -->
      <ng-container *ngIf="showSplitPicker && showSplitConfig && m.id !== paidById">
        <div class="flex items-center gap-1 shrink-0">
          <span *ngIf="splitType.toUpperCase() === 'EXACT'" class="text-[10px] text-gray-400">$</span>
          <input type="number" min="0" [value]="splitValues[m.id] || 0"
            (input)="onSplitInput(m.id, $event)"
            class="w-16 h-6 bg-neutral-soft dark:bg-dark-tertiary border border-neutral-border dark:border-dark-border rounded-md px-1.5 text-[11px] text-right text-gray-900 dark:text-dark-text outline-none" />
          <span *ngIf="splitType.toUpperCase() === 'PERCENTAGE'" class="text-[10px] text-gray-400">%</span>
        </div>
      </ng-container>
    </div>
  </div>

</div>
